import lahiError from '../../lahi-error/lahi-error.vue';
import { required, between } from 'vuelidate/lib/validators';
import { NUMBER_OF_CHILDREN } from './lahi-calculator-form-consts';
import { mapState, mapActions } from 'vuex';

import VueCurrencyInput from '@ui-common/vue-currency-input';
import VueInput from '@ui-common/vue-input';
import VueSlider from '@ui-common/vue-slider';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueErrorMessage from '@ui-common/vue-error-message';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueFormInfo from '@ui-common/vue-form-info';

const AMOUNT_DIVISIBLE_BY = 1000;
const AMOUNT_ROUNDIG_LIMIT = 500;
const AMOUNT_SLIDER_DESKTOP_INTERVAL = 100000;
const DURATION_SLIDER_DESKTOP_INTERVAL = 1;
const SCROLL_TO_RESULT_DURATION = 400;
const REPREZENTATIV_PELDA_TA = 'PELDA';
const MLTL_ACCORDION_SELECTOR = '.mltl-accordion';
const MJBL_ACCORDION_SELECTOR = '.mjbl';

const getMinimumValue = (backendMinValue, backendMaxValue, shiwaValue) => {
	return backendMinValue <= shiwaValue && shiwaValue <= backendMaxValue ? shiwaValue : backendMinValue;
};
const getMaximumValue = (backendMinValue, backendMaxValue, shiwaValue) => {
	return backendMinValue <= shiwaValue && shiwaValue <= backendMaxValue ? shiwaValue : backendMaxValue;
};
const isItNumber = (value) => {
	return !isNaN(parseInt(value, 10));
};
const betweenNumbers = (value, min, max) => {
	return min <= value && value <= max;
};
const validateInitData = (value, min, max) => {
	return isItNumber(value) && betweenNumbers(value, min, max);
};
export default {
	data() {
		return {
			initialized: false,
			model: {
				amount: null,
				children: null,
				csok: null,
				csokCountry: null,
				duration: null,
				income: null,
				loyaltyDiscount: false
			},
			showDurationEduTooltip: {
				min: false,
				max: false
			},
			showAmountEduTooltip: {
				min: false,
				max: false
			},
			preventEduTooltipClose: false,
			slider: {
				amount: null,
				duration: null
			},
			hasCalculationRanOnce: false
		};
	},
	props: {
		shiwaInitData: {},
		backendInitData: {},
		sectionAriaLabelledby: {},
		isActiveTab: {
			default: true
		},
		tabIndex: {
			default: 0
		}
	},
	components: {
		lahiError,
		VueCheckbox,
		VueCurrencyInput,
		VueErrorMessage,
		VueFormInfo,
		VueInput,
		VueRadioGroup,
		VueSelect,
		VueSelectOption,
		VueSlider
	},
	validations() {
		let model = {};
		model.amount = this.sliderRanges ? { required, between: between(this.sliderRanges.amountMin, this.sliderRanges.amountMax) } : {};
		model.duration = this.sliderRanges
			? { required, between: between(this.sliderRanges.durationMin, this.sliderRanges.durationMax) }
			: {};
		model.children = {};
		return { model };
	},
	computed: {
		...mapState('lahi', ['hasCalculation', 'calculationInProgress', 'calculationTechnicalError', 'layoutCategory']),
		amoutSliderOptions() {
			return {
				id: 'lcf-amount',
				addon: `Min. ${this.amountMinLabel}, max. ${this.amountMaxLabel}`,
				postfix: 'Ft',
				maxWidth: 250
			};
		},
		durationSliderOptions() {
			return {
				id: 'lcf-years',
				addon: `Min. ${this.durationMinLabel}, max. ${this.durationMaxLabel}`,
				postfix: 'év',
				maxWidth: 110
			};
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		NUMBER_OF_CHILDREN() {
			return NUMBER_OF_CHILDREN;
		},

		numberOfChildren() {
			return this.NUMBER_OF_CHILDREN.map((child) => {
				return {
					key: child.value,
					value: child.label
				};
			});
		},

		DURATION_SLIDER_DESKTOP_INTERVAL() {
			return DURATION_SLIDER_DESKTOP_INTERVAL;
		},
		AMOUNT_SLIDER_DESKTOP_INTERVAL() {
			return AMOUNT_SLIDER_DESKTOP_INTERVAL;
		},
		sliderRanges() {
			return this.backendInitData
				? {
						durationMin: getMinimumValue(
							this.backendInitData.durationMin,
							this.backendInitData.durationMax,
							this.shiwaInitData.loanDurationMinimum
						),
						durationMax: getMaximumValue(
							this.backendInitData.durationMin,
							this.backendInitData.durationMax,
							this.shiwaInitData.loanDurationMaximum
						),
						amountMin: getMinimumValue(
							this.backendInitData.amountMin,
							this.backendInitData.amountMax,
							this.shiwaInitData.loanAmountMinimum
						),
						amountMax: getMaximumValue(
							this.backendInitData.amountMin,
							this.backendInitData.amountMax,
							this.shiwaInitData.loanAmountMaximum
						)
				  }
				: null;
		},
		showLoyaltyDiscountError() {
			return !this.model.income && this.model.loyaltyDiscount && this.hasCalculationRanOnce;
		},
		amountMinLabel() {
			return this.$options.filters.currency(this.sliderRanges.amountMin, 'HUF') + ' Ft';
		},

		amountMaxLabel() {
			return this.$options.filters.currency(this.sliderRanges.amountMax, 'HUF') + ' Ft';
		},
		durationMinLabel() {
			return this.sliderRanges.durationMin + ' év';
		},
		durationMaxLabel() {
			return this.sliderRanges.durationMax + ' év';
		}
	},
	methods: {
		calculate() {
			this.correctAmount(true);
			this.correctDuration();
			this.$v.$touch();
			this.hasCalculationRanOnce = true;
			if (!this.$v.model.$invalid) {
				this.$emit('on-calculate', this.model);
			}
		},
		removeEduTooltips() {
			if (!this.preventEduTooltipClose) {
				this.showDurationEduTooltip = { min: false, max: false };
				this.showAmountEduTooltip = { min: false, max: false };
			}
			this.preventEduTooltipClose = false;
		},
		validateDuration(tooltipNeeded) {
			let showDurationEduTooltip = this.correctDuration();
			if (tooltipNeeded) {
				this.showDurationEduTooltip = showDurationEduTooltip;
				this.preventEduTooltipClose = true;
			}
		},
		validateAmount(tooltipNeeded) {
			let showAmountEduTooltip = this.correctAmount(true);
			if (tooltipNeeded) {
				this.showAmountEduTooltip = showAmountEduTooltip;
				this.preventEduTooltipClose = true;
			}
		},
		correctDuration() {
			this.model.duration = Math.round(this.model.duration);
			if (this.model.duration < this.sliderRanges.durationMin) {
				this.model.duration = this.sliderRanges.durationMin;
				return { min: true, max: false };
			} else if (this.model.duration > this.sliderRanges.durationMax) {
				this.model.duration = this.sliderRanges.durationMax;
				return { min: false, max: true };
			}
			return { min: false, max: false };
		},
		correctAmount(roundNeeded) {
			if (this.model.amount < this.sliderRanges.amountMin) {
				this.model.amount = this.sliderRanges.amountMin;
				return { min: true, max: false };
			} else if (this.model.amount > this.sliderRanges.amountMax) {
				this.model.amount = this.sliderRanges.amountMax;
				return { min: false, max: true };
			} else if (roundNeeded && this.model.amount % AMOUNT_DIVISIBLE_BY != 0) {
				// ezresre kerekítés
				if (this.model.amount % AMOUNT_DIVISIBLE_BY < AMOUNT_ROUNDIG_LIMIT) {
					this.model.amount -= this.model.amount % AMOUNT_DIVISIBLE_BY;
				} else {
					this.model.amount += AMOUNT_DIVISIBLE_BY - (this.model.amount % AMOUNT_DIVISIBLE_BY);
				}
			}
			return { min: false, max: false };
		},
		resetValidations() {
			this.$v.model.children.$reset();
		},
		addToDuration(value) {
			this.model.duration += value;
			this.correctDuration();
		},
		addToAmount(value) {
			this.model.amount += value;
			this.correctAmount(true);
		},
		reprezentativPeldaTa() {
			let taData = {
				eventType: REPREZENTATIV_PELDA_TA + '_' + this.layoutCategory,
				dataElements: []
			};
			this.sendTa(taData);
			setTimeout(() => {
				const representativeContainer =
					document.querySelector(MLTL_ACCORDION_SELECTOR) || document.querySelector(MJBL_ACCORDION_SELECTOR);
				if (representativeContainer) {
					let firstAccordionButton = representativeContainer.querySelector('button');
					if (firstAccordionButton) {
						firstAccordionButton.focus();
					}
				}
			});
		},
		clearIncome() {
			if (!this.model.loyaltyDiscount) {
				this.model.income = null;
			}
		},
		setShiwaInitData(newValue) {
			this.model.amount = isItNumber(newValue.loanAmountDefault) ? parseInt(newValue.loanAmountDefault, 10) : this.model.amount;
			this.model.duration = isItNumber(newValue.loanDurationDefault)
				? parseInt(newValue.loanDurationDefault, 10)
				: this.model.duration;
			this.model.csok = typeof this.model.csok === 'boolean' ? this.model.csok : newValue.csokQuestionActive;
			this.model.csokCountry =
				typeof this.model.csokCountry === 'boolean' ? this.model.csokCountry : newValue.csokCountryQuestionActive;
		},
		...mapActions('lahi', ['sendTa']),
		showTooltip(type, prop) {
			if (type == 'amount') {
				this.preventEduTooltipClose = true;
				this.showAmountEduTooltip[prop] = true;
			} else if (type == 'duration') {
				this.preventEduTooltipClose = true;
				this.showDurationEduTooltip[prop] = true;
			}
		}
	},
	watch: {
		backendInitData: {
			handler(newValue) {
				if (newValue) {
					this.model.amount = validateInitData(newValue.amount, newValue.amountMin, newValue.amountMax)
						? parseInt(newValue.amount, 10)
						: this.model.amount;
					this.model.children = isItNumber(newValue.children) ? parseInt(newValue.children, 10) : this.model.children;
					this.model.csok = typeof newValue.csok === 'boolean' ? newValue.csok : this.model.csok;
					this.model.csokCountry = typeof newValue.csokCountry === 'boolean' ? newValue.csokCountry : this.model.csokCountry;
					this.model.duration = validateInitData(newValue.duration, newValue.durationMin, newValue.durationMax)
						? parseInt(newValue.duration, 10)
						: this.model.duration;
					this.model.income = isItNumber(newValue.income) ? parseInt(newValue.income, 10) : this.model.income;
					this.model.loyaltyDiscount =
						typeof newValue.loyaltyDiscount === 'boolean' ? newValue.loyaltyDiscount : this.model.loyaltyDiscount;
					this.slider.amount = this.model.amount;
					this.slider.duration = this.model.duration;
					this.validateDuration(false);
					this.validateAmount(false);
					this.resetValidations();
					this.initialized = true;
				}
			},
			immediate: true
		},
		shiwaInitData: {
			handler(newValue) {
				if (newValue) {
					this.model.amount = isItNumber(newValue.loanAmountDefault)
						? parseInt(newValue.loanAmountDefault, 10)
						: this.model.amount;
					this.model.duration = isItNumber(newValue.loanDurationDefault)
						? parseInt(newValue.loanDurationDefault, 10)
						: this.model.duration;
					this.model.csok = typeof this.model.csok === 'boolean' ? this.model.csok : newValue.csokQuestionActive;
					this.model.csokCountry =
						typeof this.model.csokCountry === 'boolean' ? this.model.csokCountry : newValue.csokCountryQuestionActive;
				}
			},
			immediate: true
		},
		'model.amount'(newValue) {
			if (this.sliderRanges && this.sliderRanges.amountMin <= newValue && newValue <= this.sliderRanges.amountMax) {
				this.slider.amount = newValue;
			}
		},
		'slider.amount'(newValue) {
			this.model.amount = newValue;
		},
		'model.duration'(newValue) {
			if (this.sliderRanges && this.sliderRanges.durationMin <= newValue && newValue <= this.sliderRanges.durationMax) {
				this.slider.duration = newValue;
			}
		},
		'slider.duration'(newValue) {
			this.model.duration = newValue;
		},
		calculationInProgress(newValue) {
			if (!newValue && (this.hasCalculation || this.calculationTechnicalError) && this.isActiveTab) {
				this.$scrollTo(this.$refs['calculator-buttons'], { duration: SCROLL_TO_RESULT_DURATION });
			}
		}
	},
	mounted() {
		document.body.addEventListener('click', this.removeEduTooltips);
	},
	beforeDestroy() {
		document.body.removeEventListener('click', this.removeEduTooltips);
	}
};
